var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGameRules(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.501 16.9998L10.412 16.8664C9.79455 15.9402 9.48582 15.4771 9.07793 15.1418C8.71682 14.845 8.30074 14.6223 7.85349 14.4865C7.34828 14.3331 6.79171 14.3331 5.67857 14.3331H4.45651C3.46086 14.3331 2.96303 14.3331 2.58274 14.1393C2.24823 13.9689 1.97627 13.6969 1.80583 13.3624C1.61206 12.9821 1.61206 12.4843 1.61206 11.4886V3.8442C1.61206 2.84855 1.61206 2.35073 1.80583 1.97044C1.97627 1.63593 2.24823 1.36396 2.58274 1.19352C2.96303 0.999756 3.46086 0.999756 4.45651 0.999756H4.81206C6.80336 0.999756 7.79901 0.999756 8.55958 1.38729C9.2286 1.72817 9.77253 2.2721 10.1134 2.94112C10.5009 3.7017 10.501 4.69735 10.501 6.68864M10.501 16.9998V6.68864M10.501 16.9998L10.5899 16.8664C11.2073 15.9402 11.5161 15.4771 11.924 15.1418C12.2851 14.845 12.7012 14.6223 13.1484 14.4865C13.6536 14.3331 14.2102 14.3331 15.3233 14.3331H16.5454C17.541 14.3331 18.0389 14.3331 18.4192 14.1393C18.7537 13.9689 19.0256 13.6969 19.1961 13.3624C19.3898 12.9821 19.3898 12.4843 19.3898 11.4886V3.8442C19.3898 2.84855 19.3898 2.35073 19.1961 1.97044C19.0256 1.63593 18.7537 1.36396 18.4192 1.19352C18.0389 0.999756 17.541 0.999756 16.5454 0.999756H16.1898C14.1985 0.999756 13.2029 0.999756 12.4423 1.38729C11.7733 1.72817 11.2294 2.2721 10.8885 2.94112C10.501 3.7017 10.501 4.69735 10.501 6.68864",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameRules);
export default __webpack_public_path__ + "static/media/game-rules.4363860ed3ab9eb0685367c3d67e251e.svg";
export { ForwardRef as ReactComponent };